import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { MainAppReducer } from 'Types';
import * as appActions from '../../Actions/app';
import { useEffect, useState } from 'react';
import { CustomSwitch } from 'Components/StyledComponents';
import { COLORBLIND_TYPE } from 'Utils/Constants';
import logger from 'Utils/Logger';
import { settingsCardSx, settingsCardContentSx } from './settingsLayout';

const Accessibility = () => {
  const data = useSelector((state: MainAppReducer) => state.mainAppReducer);
  const { userData } = data;
  useEffect(() => {
    logger.info(
      'COLORBLOIND TYPE',
      userData?.colorblind_type,
      userData?.colorblind_type === COLORBLIND_TYPE.RED_GREEN,
    );
  }, [userData?.colorblind_type]);
  const [fullColorblindSwitch, setFullColorblindSwitch] = useState(
    userData?.colorblind_type === COLORBLIND_TYPE.FULL,
  );
  const [redGreenColorblindSwitch, setRedGreenColorblindSwitch] = useState(
    userData?.colorblind_type === COLORBLIND_TYPE.RED_GREEN,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (fullColorblindSwitch) {
      // setRedGreenColorblindSwitch(false)
      dispatch(appActions.setColorblindType(COLORBLIND_TYPE.FULL));
    }
    if (redGreenColorblindSwitch) {
      // setFullColorblindSwitch(false)
      dispatch(appActions.setColorblindType(COLORBLIND_TYPE.RED_GREEN));
    }
    if (!fullColorblindSwitch && !redGreenColorblindSwitch) {
      dispatch(appActions.setColorblindType(null));
    }
  }, [fullColorblindSwitch, redGreenColorblindSwitch, dispatch]);

  useEffect(() => {
    logger.info(
      'userData?.colorblind_type === COLORBLIND_TYPE.FULL?',
      userData?.colorblind_type === COLORBLIND_TYPE.FULL,
    );
    // if(userData?.colorblind_type === COLORBLIND_TYPE.FULL && !fullColorblindSwitch){
    //   setFullColorblindSwitch(true)
    // }
    // logger.info("userData?.colorblind_type === COLORBLIND_TYPE.RED_GREEN?",userData?.colorblind_type === COLORBLIND_TYPE.RED_GREEN)

    // if(userData?.colorblind_type === COLORBLIND_TYPE.RED_GREEN && !redGreenColorblindSwitch){
    //   setRedGreenColorblindSwitch(true)
    // }
    // if(userData?.colorblind_type === null && (fullColorblindSwitch || redGreenColorblindSwitch)) {
    //   setRedGreenColorblindSwitch(false)
    //   setFullColorblindSwitch(false)
    // }
  }, [userData?.colorblind_type]);

  return (
    <Box sx={{ height: 'calc(100vh - 200px)', overflow: 'scroll' }}>
      <Box
        sx={{
          ...settingsCardSx,
          backgroundColor: 'black',
          borderRadius: '5px',
        }}
      >
        <Box
          sx={{
            color: 'white',
            textAlign: 'left',
            ...settingsCardContentSx,
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              marginTop: '20px',
              marginBottom: '20px',
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '26px',
              letterSpacing: '0.01em',
              color: '#FFFFFF',
              fontFamily: 'Lato',
            }}
          >
            Color Theme
          </Box>

          <Box sx={{ marginBottom: '20px', fontFamily: 'Lato' }}>
            <Box sx={{ display: 'flex', flexDirection: 'vertical', alignItems: 'center' }}>
              <CustomSwitch
                onChange={() => {
                  setRedGreenColorblindSwitch(!redGreenColorblindSwitch);
                  if (!redGreenColorblindSwitch) {
                    setFullColorblindSwitch(false);
                  }
                }}
                checked={redGreenColorblindSwitch}
              />
              <Box sx={{ display: 'flex', alignItems: 'center', height: '25px' }}>
                Red/Blue Mode
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'vertical', alignItems: 'center' }}>
              <CustomSwitch
                onChange={() => {
                  setFullColorblindSwitch(!fullColorblindSwitch);
                  if (!fullColorblindSwitch) {
                    setRedGreenColorblindSwitch(false);
                  }
                }}
                checked={fullColorblindSwitch}
              />
              <Box sx={{ display: 'flex', alignItems: 'center', height: '25px' }}>
                Monochrome Mode
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Accessibility;
